<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import cornerBraces from './images/IMG_0606.jpg';
	import insertCorner from './images/Insert-backside-700x700.jpg';
</script>

<Section class="max-md:pt-0">
	<h2>Indow Innovations Brought the Missing Piece to Window Inserts</h2>
	<p>
		You might have noticed that the back corners of our Indow window inserts
		have a piece missing. It’s not really missing, it’s designed that way. The
		cut out piece prevents the corner from buckling and creating gaps between
		the tubing and window frame. It’s how we get the most insulated windows.
	</p>
	<Image
		src={insertCorner}
		alt="Indow window insert with back corner cut out for properly insulated windows"
	/>
	<p>
		When the window inserts are pressed into place, there is compression all
		along the tubing. The corner piece of the frame is compressed from two
		different directions at once. To absorb that compression, the cutout allows
		the corner piece to rotate back into the window frame. The “corner brace” as
		we call it, gives the corner of the tube the rigidity it needs to spring
		back and allows the corners to be snug and tight without buckling.
	</p>
	<p>
		The material you see exposed—the corner brace—is a smaller foam silicone
		tube that sits inside the larger silicone tube edging the acrylic panel. Our
		window inserts didn’t start out that way.
	</p>
	<Image
		src={cornerBraces}
		alt="Box full of corner braces that go in Indow window insert tubes"
	/>
	<p>
		We knew some part of our solid tubing surrounding the window inserts had to
		be removed in order for our compression system to work. We used to hand
		punch ¾” round dots from sheets of open cell foam and individually glue them
		into the corners. Someone would be sitting there with a round punch and a
		hammer and just whack, whack, whack… But those pieces would become
		discolored and lose their springiness over time.
	</p>
	<p>
		Now we have them molded out of silicone, saving us production time and
		giving us a more functional and durable solution. We simply cut out part of
		the really strong silicone tubing, pop the reinforcing corner brace inside,
		which allows a graceful collapse, but keeps it strong enough to fill in the
		corner without any gaps.
	</p>
	<p>
		It’s a simple and elegant solution to ensure our window inserts have the
		best compression and create the most insulated windows. Indow window inserts
		are always improving thanks to our innovative and creative team.
	</p>
</Section>
